module.exports = __webpack_public_path__ + "static/webrtc infrastructure as code-26de31efa6866f1bd3874eaedeb6614f.webp";